import { render, staticRenderFns } from "./ChatBoxTextButton.vue?vue&type=template&id=395f5af3&scoped=true&"
import script from "./ChatBoxTextButton.vue?vue&type=script&lang=js&"
export * from "./ChatBoxTextButton.vue?vue&type=script&lang=js&"
import style0 from "./ChatBoxTextButton.vue?vue&type=style&index=0&id=395f5af3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395f5af3",
  null
  
)

export default component.exports